import React from 'react';
import { Layout } from '../components/layout/Layout';
import { BackButton } from '../components/BackButton';
import { ComingSoonCard } from '../components/ComingSoonCard';
import '../styles/dashboard.css';

export const PrintPage = () => (
  <Layout>
    <div style={{ paddingTop: 40 }}>
      <BackButton />
      <ComingSoonCard
        title="Print Deck"
        description="Generate printable flashcard sheets from any deck — perfect for in-person therapy sessions and home practice. Coming soon."
      />
    </div>
  </Layout>
);
